"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseSeparator, type BaseSeparatorProps } from "./separator";
import ConEdisonSeparator from "./separator.con-edison";

export function Separator(props: BaseSeparatorProps) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return <ConEdisonSeparator {...props} variant="default" />;

    default:
      return <BaseSeparator {...props} />;
  }
}
